export default "__VITE_ASSET__BPCJx5JE__"